// extracted by mini-css-extract-plugin
export const popupBox = "QAModal-module--popup-box--1LADl";
export const modalCansell = "QAModal-module--modal-cansell--1v_Oe";
export const helpTitle = "QAModal-module--help-title--2c81z";
export const helpSubtitle = "QAModal-module--help-subtitle--13yUs";
export const helpText = "QAModal-module--help-text--1x2BI";
export const helpContents = "QAModal-module--help-contents--3diMa";
export const modalContents = "QAModal-module--modal-contents--3tnKN";
export const close = "QAModal-module--close--qOGIu";
export const mask = "QAModal-module--mask--3O3yW";
export const iconClose = "QAModal-module--icon-close--CWaSn";
export const maskClose = "QAModal-module--mask-close--3CZ0A";